/* eslint-disable no-unused-vars */
import { z } from 'zod';

export enum AUTH_CHALLENGE_NAME {
  CUSTOM_CHALLENGE = 'CUSTOM_CHALLENGE',
  CUSTOM_WITHOUT_SRP = 'CUSTOM_WITHOUT_SRP',
  CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE = 'CONFIRM_SIGN_IN_WITH_CUSTOM_CHALLENGE',
}

export enum USER_GROUP {
  ADMIN = 'admin',
}

export enum ROLE_TYPES {
  ADMIN = 'admin',
  LOCATION_ADMIN = 'location_admin',
  ASSESSOR = 'assessor',
  ISSUER = 'issuer',
  REQUESTER = 'requester',
  READER = 'reader',
  TENANT = 'tenant',
}

export const roleTypes = z.nativeEnum(ROLE_TYPES);

export type Role = z.infer<typeof roleTypes>;
/* eslint-enable no-unused-vars */
